export const genderOptions = [
    {value:"male", label: "Male"},
    {value:"female", label:"Female"}
]

export const maritalStatusOptions = [
    {value:"single", label:"Single"},
    {value:"married", label: "Married"},
    {value:"widowed", label: "Widowed"},
    {value:"divorced", label: "Divorced"},


]

export const statusOptions = [
    { value: "open", label: "Open" },
    { value: "closed", label: "Closed" },
    // { value: "Cancelled", label: "Cancelled" },
  ];

export const primaryColor = "#D3001A "
export const primaryRedGradient = "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)"

export const documentTypeOptions = [
    {value:"user", label:"User"},
    {value:"company", label:"Company"},
    {value:"store", label:"Store"}
]


export const residencyOptions = [
    {value:"visit", label: "Visit"},
    {value:"resident", label:"Resident"},
    {value:"dependent", label:"Dependent"},
    {value:"uae citizen", label:"UAE"}
]

export const uniformTypeOptions = [
    {value:"M", label:"Male"},
    {value:"F", label: "Female"},
    {value:"U", label: "Unisex"}
]

export const uniformGenderOptions = [
    {value:"M", label:"Male"},
    {value:"F", label: "Female"},
    {value:"U", label: "Unisex"}
]

export const activeStatusOptions = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" }   
  ];

  export const uniformColors = [
    { name: "Red", value: "#FF0000" },
    { name: "Green", value: "#008000" },
    { name: "Blue", value: "#0000FF" },
    { name: "Yellow", value: "#FFFF00" },
    { name: "Purple", value: "#800080" },
    { name: "Orange", value: "#FFA500" },
    { name: "Pink", value: "#FFC0CB" },
    { name: "Brown", value: "#A52A2A" },
    { name: "Black", value: "#000000" },
    { name: "White", value: "#FFFFFF" },
    { name: "Gray", value: "#808080" },
    { name: "Cyan", value: "#00FFFF" }
  ];

export const leaveStatusOptions = [
    {label:"All", value: "all"},
    {label:"Pending", value: "pending"},
    {label:"Approved", value: "approved"},
    {label:"Rejected", value: "rejected"},
    {label:"Cancelled", value: "cancelled"},
    {label:"Cancel Pending", value: "cancel_pending"},
    {label:"Cancel Rejected", value: "cancel_rejected"},
    {label:"Cancel Approved", value: "cancel_approved"},

  ]


  export const resignationStatusOptions = [ 
    {label:"Approved", value: "approve"},
    {label:"Rejected", value: "reject"},
    {label:"Cancelled", value: "cancel"}

  ]


  export const jobStatusOptions = [
    {label:"Applied", value: "applied"},
    {label:"Hired", value: "hired"},
    {label:"Rejected", value: "rejected"},
    {label:"Reviewed", value: "reviewed"},
    {label:"Shortlisted", value: "shortlisted"},

    


  ]

  export const uniformAllocationStatusOptions = [
    {label:"Received", value: "received"},
    // {label:"Replaced", value: "replaced"},
    {label:"Damage", value: "damaged"},
    // {label:"Approve", value: "approved"},
    {label:"Initiate", value: "initiated"},
    {label:"Allocate", value: "allocated"},
    // {label:"Requested", value: "requested"},
    {label:"Acknowledge", value: "acknowledged"}


  ]

export const eosOptions = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" }
];

export const documentExpiryStatusOptions = [
  { value: "active", label: "Active" },
  { value: "expired", label: "Expired" },
];

// Values are what the backend's `expiry_in` filter understands: "today" or a
// number of days, inclusive of today. The server does the date maths so a
// shared URL keeps meaning "next 7 days" tomorrow as well.
export const documentExpiresInOptions = [
  { value: "today", label: "Today" },
  { value: "7", label: "7 days" },
  { value: "30", label: "30 days" },
  { value: "60", label: "60 days" },
  { value: "90", label: "90 days" },
];

// Document list scope. The backend defaults to "active" when nothing is sent.
export const documentStatusOptions = [
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
  { value: "all", label: "All" },
];
